import './api';
import './coldcreek';
import 'swiper';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        'how_it_works': {
            init: function() {
                window.__initSecondaryNav = false;
            }
        },
        // All pages
        'common': {
            init: function() {
              window.__initSecondaryNav = true;
            },
            finalize: function() {
                var mySwiper = new Swiper('.clients-gallery', {
                    direction: 'horizontal',
                    loop: true,

                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',

                    pagination: '.swiper-pagination',
                    paginationClickable: true

                });

                // Secondary nav
                var topCta = null;
                var tabs = $('.text-and-image > ul > li');

                var attachSubNav = function() {
                        var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

                        var _offset = $('.text-and-image').offset().top - 124;
                        var _endOffset = _offset + $('.text-and-image').height();
                        var navbar = $(".text-and-image-tabs");

                        if (!navbar.hasClass('show') && top > _offset && top < _endOffset) {
                            navbar.addClass('show');
                        } else if (navbar.hasClass('show') && (top < _offset || top > _endOffset)) {
                            navbar.removeClass('show');
                        }

                        if (navbar.hasClass('show')) {
                            var selectedItem = 0;
                            var selectedItem2 = 0;
                            var __tabs = $('.text-and-image-tabs .tab-');
                            var __textNImage = $('.text-n-image');

                            tabs.each(function(i, e) {
                                if ((top + 199) > $(this).offset().top) {
                                    selectedItem = i;
                                }
                            });

                            __textNImage.each(function(i, e) {
                                if ((top + 199) > $(this).offset().top) {
                                    selectedItem2 = i;
                                }
                            });
                            var _selection = __tabs.get(selectedItem);
                            __tabs.not(_selection).removeClass('active');
                            $(_selection).addClass('active');
                            var _selection2 = __textNImage.get(selectedItem2);
                            __textNImage.not(_selection2).removeClass('orange-headline');
                            $(_selection2).addClass('orange-headline');

                        } else {
                            $('.text-n-image.orange-headline').removeClass('orange-headline');
                        }
                };

                if (window.__initSecondaryNav && $('.text-and-image').length) {
                    $(window).scroll(attachSubNav);
                    attachSubNav();
                }

                $('.reveal-box__read-more').click(function(e) {
                    e.preventDefault();
                    var parent = $(this).parents('.reveal-box');
                    parent.toggleClass('reveal');
                    if (parent.hasClass('reveal')) {
                        $(this).text('READ LESS').addClass('read-less');
                    } else {
                        var me = $(this);
                        setTimeout(function() {
                            me.text('READ MORE').removeClass('read-less');
                        }, 500);
                    }
                });

                $('.mobile-nav-icon').click(function() {
                  $('.menu-container').toggleClass('open');
                });
                $('.closed-icon').click(function(){
                  $('.menu-container').removeClass('open');
                });

                $('#menu-main-menu a').click(function(e) {
                  if (window.innerWidth <= 800) {
                    e.stopPropagation();
                    var ul = $(this).siblings('ul.sub-menu');
                    if (ul.length) {
                      if (ul.is(':visible')) {
                        return true;
                      } else {
                        $('ul.sub-menu').not(ul).hide();
                        ul.show();
                        return false;
                      }
                    }
                  }
                  return true;

                });
                $('#menu-main-menu a').click(function(){
                  $(this).addClass('changed');
                  $('#menu-main-menu a').not(this).removeClass('changed');
                });

            },
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'contact_us': {
          finalize: function() {
            $('.inquiry-dropdown').select2({
              minimumResultsForSearch: Infinity,
            });
          }
        },
        'jobs': {
          finalize: function() {
            $('.job-title').select2({
              minimumResultsForSearch: Infinity,
            });

          }
        },
        'metis_ecosystem': {
          init: function() {

          },
          finalize: function() {
              // Metis Ecosystem
              $('.slide-reveal-grid .item').click(function() {
                  var _this = $(this);
                  $.each($(this)[0].classList, function(i, e) {
                      if (e.indexOf('item-') === 0) {
                          var detailsClass = e.replace('item', 'details');
                          var detail = $('.slide-reveal-grid .' + detailsClass);
                          if (detail.length) {
                              if (detail.hasClass('reveal')) {
                                  // _this.removeClass('reveal');
                                  // detail.removeClass('reveal');
                              } else {
                                  $('.slide-reveal-grid .item.reveal')
                                      .not(_this)
                                      .removeClass('reveal');
                                  $('.slide-reveal-grid .details.reveal')
                                      .not(detail)
                                      .removeClass('reveal');
                                  _this.addClass('reveal');
                                  detail.addClass('reveal');
                              }
                          }
                      }
                  });
              });

          }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



// WEBPACK FOOTER //
// ./assets/js/main.js